import { ConfigType } from '../utils/requestAPI';

type updatePersonsalInfoDataType = {
  fullName?: string;
  avatar?: string;
  FormData?: any;
  contactInfo?: {
    phoneNumber?: string;
  };
};

type updateContactInfoDataType = {
  contactInfo: {
    address1: string;
    address2: string;
    city: string;
    country: string;
    postalCode: string;
    phoneNumber?: string;
  };
};

type updateCompanyInfoDataType = {
  companyDetails: {
    companyName: string;
  };
};
type certificationsPayload = {
  name: String;
  issuer: String;
  year: String;
  pdf: String[];
};
type licensesPayload = {
  licenseName: String;
  licenseNumber: String;
  issuingAuthority: String;
  expiryDate: String;
  img: String[];
};
type updateTechnicianDocuments = {
  certifications: certificationsPayload[];
  licenses: licensesPayload[];
};
type deleteTechnicianDocuments = {
  documentType: String;
  licenseNumber?: String;
  name?: String;
};

const settingsApi = {
  updatePersonalInfo: (data: updatePersonsalInfoDataType): ConfigType => {
    return {
      url: '/users/update-profile',
      method: 'patch',
      data: data,
    };
  },

  updateContactInfo: (data: updateContactInfoDataType): ConfigType => {
    return {
      url: '/users/update-profile',
      method: 'patch',
      data: data,
    };
  },

  updateCompanyInfo: (data: updateCompanyInfoDataType): ConfigType => {
    return {
      url: '/users/update-profile',
      method: 'patch',
      data: data,
    };
  },
  updateTechnicianDocuments: (data: updateTechnicianDocuments): ConfigType => {
    return {
      url: '/users/update-profile',
      method: 'patch',
      data: data,
    };
  },
  deleteCertification: (data: deleteTechnicianDocuments): ConfigType => {
    return {
      url: '/users/technician-documents/delete',
      method: 'patch',
      data: data,
    };
  },
};

export default settingsApi;
